let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lWRQh")).then(() => parcelRequire('44Req'));